import { EditorView } from '@codemirror/view';

export const customGutterStyle = EditorView.theme({
  '.cm-gutter': { width: '34px' },
});
